import React from 'react'

const Reset = (props) => {

    const resetScroll = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <div className="row">
            <div className="col-lg-12 text-center">
                <button className="btn btn-primary js-scroll-trigger" style={{color: '#000'}} onClick={resetScroll}>Vai all'inizio</button>
            </div>
        </div>
    )
}

export default Reset;